import Vue from 'vue'
const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-format'), require('d3-geo'), require('d3-scale'), require('d3-array'), require('d3-transition'), require('d3-ease'), require('d3-axis'))

const resourceEndpoint = 'https://www.straitstimes.com/multimedia/graphics/json/'

const store = Vue.observable({
  rawData: null
})

d3.json(resourceEndpoint + '1Bic3Z0b2t5aB1BoKcrQ_8zphKq9b95ZUPVfI3rH-SLU/929734161.json', d => {
  store.rawData = Object.freeze(d)
})

export {store}
